import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select"]

  initialize() {
    this.element.addEventListener("$select2:select", this.handleChange)
  }

  handleChange(event) {
    $("#suggestion_card").removeClass("hidden");
    $("#suggestion_loading").removeClass("hidden");
    $("#suggestion_results").html("");
    $("#suggestion_regenerate").addClass("hidden");
    $("#suggestion_regenerate").off("click");

    $.ajax({
      url: '/api/v1/tasks/' + this.dataset.taskId + '/topic_proposals/suggest_titles',
      type: 'GET',
      data: { keyword_id: event.detail.event.params.data.id, keyword_type: event.detail.event.params.data.type },
      success: function(data) {
        $("#suggestion_loading").addClass("hidden");
        $("#suggestion_regenerate").removeClass("hidden");

        $("#suggestion_regenerate").on("click", function() {
          this.dispatchEvent(new CustomEvent("$select2:select", event));
        });

        // create radio buttons for each title in array
        var radioButtons = "";
        for (var i = 0; i < data.length; i++) {
          radioButtons += `<label class="inline-flex items-center">
            <input type="radio" name="topic_proposal[suggestion]" value="${data[i]}" class="form-radio text-indigo-600 h-4 w-4">
            <span class="ml-2">${data[i]}</span>
          </label><br>`;
        }
        $("#suggestion_results").html(radioButtons);
        $("input[name='topic_proposal[suggestion]']").on("change", function() {
          var selectedTitle = $(this).val();
          $("#topic_proposal_title").val(selectedTitle);
          $("#topic_proposal_title").focus();
        });
      }
    });
  }
}